/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link, Switch, Redirect, useLocation} from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import { Avatar } from "@material-ui/core";
import Axios from "axios";

const avatarStyle = {
  width: 150,
  height: 150
}

export function AuthPage({to = '', test}) {
  const [logo, setLogo] = useState()
  const location = useLocation(); 

  useEffect(() => {
    const slug = window.location.hostname.split('.')[0]

    Axios.get('/csp/public/'+slug).then(
      response => {
        if (response && response.data) {
          setLogo(response.data.csp.csp_logo)
        }
      }
    )
  }, [])

  const ref_link_code = location.pathname.startsWith("/l/") ? location.pathname.substring(3) : null;
  const invitation_link_code = location.pathname.startsWith("/invite/") ? location.pathname.substring(8) : null;

  let can_create_account = false;

  if(ref_link_code) {
    to = `?l=${ ref_link_code }`
    can_create_account = true;
  }
  
  else if(invitation_link_code) {
    to = `?i=${ invitation_link_code }`
    can_create_account = true;
  }

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-4.jpg")})`,
            }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <div className="flex-column-auto mt-5 pb-lg-0 pb-10">
                {logo && (<Avatar
                  variant="rounded"
                  style={avatarStyle}
                  src={logo}/>)}
              </div>
              {/* end:: Aside header */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/*begin::Content header*/}
            <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              { can_create_account && (
                <>
                  <span className="font-weight-bold text-dark-50">
                    Don't have an account yet?
                  </span>
                  <Link
                    to={"/auth/registration" + to}
                    className="font-weight-bold ml-2"
                    id="kt_login_signup"
                  >
                    Sign Up!
                  </Link>
                </>
              ) }
            </div>
            {/*end::Content header*/}

            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <ContentRoute path="/auth/login">
                  <Login />
                </ContentRoute>
                <ContentRoute
                  path="/auth/registration"
                  component={Registration}
                />
                <ContentRoute
                  path="/auth/forgot-password"
                  component={ForgotPassword}
                />
                <ContentRoute
                  path="/auth/reset-password/:verification_code"
                  component={ResetPassword}
                />
                <Redirect from="/auth" exact={true} to={"/auth/login" + to} />
                <Redirect to={"/auth/login" + to} />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; 2020 Metronic
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link to="/terms" className="text-dark-75 text-hover-primary">
                  Privacy
                </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Legal
                </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Contact
                </Link>
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
